/** 请款折扣：成交价比例 %（100=原价无折）+ 折扣金额 */

export const DEFAULT_PAY_RATE = 100

export function normalizePayRate(value) {
  if (value === null || value === undefined || value === '') return DEFAULT_PAY_RATE
  const n = Number(value)
  if (!Number.isFinite(n)) return DEFAULT_PAY_RATE
  if (n < 0) return 0
  if (n > 100) return 100
  return Math.round(n * 10000) / 10000
}

/** @deprecated 兼容旧名 */
export const normalizeDiscountPct = normalizePayRate

export function grossBaseForOrderItem(quantity, unitPrice, dyeFee = 0, dyeFeeCurrency, orderCurrency = 'CNY') {
  const qty = Number(quantity) || 0
  const up = Number(unitPrice) || 0
  const dye = Number(dyeFee) || 0
  const mat = qty * up
  const dyeCur = dyeFeeCurrency || orderCurrency
  if (dyeCur === orderCurrency) return Math.round((mat + dye) * 100) / 100
  return Math.round(mat * 100) / 100
}

export function discountAmountFromGross(gross, payRatePct) {
  const g = Number(gross) || 0
  const rate = normalizePayRate(payRatePct)
  if (g <= 0 || rate >= DEFAULT_PAY_RATE) return 0
  return Math.round(g * (DEFAULT_PAY_RATE - rate)) / 100
}

export function netAfterPayRate(gross, payRatePct) {
  const g = Number(gross) || 0
  if (g <= 0) return 0
  return Math.round((g - discountAmountFromGross(g, payRatePct)) * 100) / 100
}

/** @deprecated 兼容旧名 */
export const netAfterDiscountPct = netAfterPayRate

export function formatPayRate(payRatePct) {
  const p = normalizePayRate(payRatePct)
  if (p >= DEFAULT_PAY_RATE) return `${p}%`
  const s = String(p)
  return s.includes('.') ? `${parseFloat(s)}%` : `${p}%`
}

/** @deprecated 兼容旧名 */
export const formatDiscountPct = formatPayRate

export function computeOrderItemDiscountFields(item, orderCurrency = 'CNY') {
  const gross = grossBaseForOrderItem(
    item?.quantity,
    item?.unit_price,
    item?.dye_fee,
    item?.dye_fee_currency,
    orderCurrency
  )
  const rate = normalizePayRate(item?.payment_request_discount)
  const amount = discountAmountFromGross(gross, rate)
  return { rate, amount, gross }
}
